module.exports = __webpack_public_path__ + "img/l_c8.06c4634c.png";